import { render, staticRenderFns } from "./branch-games-general-settings.vue?vue&type=template&id=0c0f053b"
import script from "./branch-games-general-settings.vue?vue&type=script&lang=js"
export * from "./branch-games-general-settings.vue?vue&type=script&lang=js"
import style0 from "./branch-games-general-settings.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/games/branch-games-general-settings.vue
// module id = hOdw
// module chunks = 0